<template>
    <div class="x-step-view">
        <el-steps v-if="config.showStepLine" :active="currentStep" align-center>
            <el-step v-for="(params, index) in config.fields" :key="index" :title="params.name" :description="params.desc"></el-step>
        </el-steps>
        <template v-for="(stepConfig, index) in config.fields" :key="index">
            <div v-if="currentStep == index">
                <x-quick-form-view v-if="stepConfig.type == ViewType.FORM"
                    ref="form"
                    :config="stepConfig"
                    :readonly="readonly || stepConfig.readonly"
                    :view-state="viewState"
                    v-model:data="stepData"
                    class="xm-form"

                    :proxy="{}"
                ></x-quick-form-view>
                <x-table-view v-if="stepConfig.type == ViewType.TABLE"
                    :config="stepConfig"
                    :readonly="readonly || stepConfig.readonly"
                    :view-state="viewState"
                    :query-params="{query:stepData}"
                    :data="getDefaultTableData(stepData, stepConfig.field)"
                ></x-table-view>
                <x-selection-view v-if="stepConfig.type == ViewType.SELECTIONS"
                    :data="data"
                    :config="stepConfig"
                    :select-type="stepConfig.selectType"
                    :selected="stepConfig.field ? stepData[stepConfig.field] : stepData"
                    @update:selected="(value)=> { if (stepConfig.field) stepData[stepConfig.field] = value; else stepData = value}"
                >
                </x-selection-view>
                <x-button-group
                    :config="getButtonsConfig(currentStep)"
                    @click="buttonClickHandler"
                ></x-button-group>
            </div>
        </template>
    </div>
</template>
<script setup>
import { defineProps, getCurrentInstance, ref, watch } from 'vue';
import XButtonGroup from '../components/base/XButtonGroup.vue';
import XQuickFormView from './XQuickFormView.vue';
import XTableView from './XTableView.vue';
import XSelectionView from './XSelectionView.vue';
import ViewType from '../dataview/ViewType';
import ViewState from './ViewState';
import { remoteCall } from '../remoteservice/RemoteService';

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },
    viewState: { default: ViewState.CREATE },
})

defineEmits({
    'update:data': null,
    'cancel': null,
})

const currentStep = ref(0);
const stepData = ref({});
let defaultData = null;
watch(()=>props.data, (value)=> {
    stepData.value = Object.assign({}, value);
    defaultData = Object.assign({}, value);
}, {immediate:true});

const CANCEL = {code:'CANCEL', name:'取消'};
const PREV = {code:'PREV', name:'上一步'};
const NEXT = {code:'NEXT', name:'下一步'};
const RESET = {code:'RESET', name:'重置'};
const FINISH = {code:'FINISH', name:props.config?.finishName || '完成',type:props.config.finishName?"danger":null};

const getButtonsConfig = (step)=> {
    let buttons = null;
    const current = step;
    if (current == 0) {
        buttons = [CANCEL, NEXT];
    } else if (current == props.config.fields.length - 1) {
        if (props.config.autoFinish && !props.config.noReset) return {align:'center', grouped:false, buttons:[CANCEL, RESET]};
        if (props.config.noReset) return {align:'center', grouped:false, buttons:[CANCEL]}
        buttons = [CANCEL, RESET, FINISH];
    } else {
        buttons = [CANCEL, PREV, NEXT];
    }
    return {align:'center', grouped:false, buttons:buttons};
}

const getDefaultTableData = (data, field)=> {
    const d = field ? data[field] : data;
    if (d instanceof Array) return d;
    return null;
}

const reset = ()=> {
    stepData.value = Object.assign({}, defaultData);
    currentStep.value = 0; 
}
const fillNext = async (data, config)=> {
    if (config.next) {
        const url = config.next.url;
        let d = data;
        if (config.next.fieldMap) {
            d = {};
            for (const [mapField, field] of Object.entries(config.next.fieldMap)) {
                d[mapField] = data[field];
            };
        }
        let datas = (await remoteCall(url, {data:d, loadingState:0}, true)).data;
        if (config.next.view) {
            datas = await config.next.view.fillDatas(datas);
        }
        if (config.next.field) data[config.next.field] = datas;
    }
}
const fillTransform = (data, config)=> {
    if (config.transform) {
        const transform = config.transform;
        const src = transform.srcField ? data[transform.srcField] : data;
        let dest = transform.destField ? data[transform.destField] : data;

        if (!src) return;
        if (!(src instanceof Array)) {
            if (!dest) dest = data[transform.destField] = {};
            if (transform.map) {
                for (const [mapField, field] of Object.entries(transform.map)) {
                    dest[mapField] = src[field];
                }
            } else {
                Object.assign(dest, src);
            }
        } else {
            if (!dest) dest = data[transform.destField] = [];
            for (const s of src) {
                const d = {};
                if (transform.map) {
                    for (const [mapField, field] of Object.entries(transform.map)) {
                        d[mapField] = s[field];
                    }
                } else {
                    Object.assign(d, s);
                }
                dest.push(d);
            }
        }
    }
}

const checkFill = async ()=> {
    const form = inst.refs.form;
    if (form && form['length']) {
        const validate = await form[0].validateForm();
        if (!validate) return false;
    }
    return true;
}

const buttonClickHandler = async (button)=> {
    // console.log('next step', props.data);

    switch (button.code) {
        case 'CANCEL': inst.emit('cancel');
        case 'PREV': currentStep.value--; break;
        case 'NEXT': 
            if (!(await checkFill())) return;
            await fillNext(stepData.value, props.config.fields[currentStep.value]);
            fillTransform(stepData.value, props.config.fields[currentStep.value]);
            currentStep.value++; 
            // checkAutoFinish(stateData);
            break;
        case 'FINISH': 
            if (!(await checkFill())) return;
            // Object.assign(props.data, defaultData.value); 
            await fillNext(stepData.value, props.config.fields[currentStep.value]);
            inst.emit('update:data', stepData.value);
            currentStep.value++; 
            break;
        case 'RESET': reset(); break;
    }
}

</script>
<style scoped>
.x-step-view >>> .el-checkbox {
    width: 100%;
    align-items: flex-start;
    height: auto;
    padding: 9px 0;
}
.x-step-view >>> .el-checkbox > span {
    white-space: normal;
}
</style>